import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel, Grid, Row, Col } from 'react-bootstrap';
import clone from 'clone';
import { classNames } from '../../utils/v4/utils';

export default class RoleForm extends Component {
  getInitialState() {
    return {
      showErrors: false,
      errors: { name: null },
    };
  }

  state = this.getInitialState();

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { showErrors } = this.state;

    if (showErrors) {
      this.validate(nextProps);
    }
  }

  onChange = event => {
    const { onEdit } = this.props;

    onEdit(event.target.name, event.target.value);
  };

  onChangePermission = event => {
    const {
      role: { perm },
      onEdit,
    } = this.props;
    const { name } = event.target;
    const permissions = perm.split('|').filter(item => item);

    if (!permissions.includes(name)) {
      permissions.push(name);
    } else {
      permissions.splice(permissions.indexOf(name), 1);
    }

    onEdit('perm', permissions.join('|'));
  };

  errorClass = error => (error ? 'error' : null);

  validate = nextProps => {
    const props = nextProps || this.props;
    const {
      role: { name },
    } = props;
    const errors = clone(this.getInitialState().errors);

    // name
    if (!name.trim()) {
      errors.name = 'This field cannot be empty.';
    } else if (!this.isUniqueName(props)) {
      errors.name = 'This is already in use.';
    }

    // show the errors
    this.setState({ showErrors: true, errors });

    // return false on any error
    return !Object.keys(errors).find(key => errors[key]);
  };

  submit = event => {
    const { isNew, onAdd, onUpdate } = this.props;

    event.preventDefault();

    if (!this.validate()) {
      return;
    }

    if (isNew) {
      onAdd();
    } else {
      onUpdate();
    }
  };

  isUniqueName = props => {
    const { roles, role } = props;
    const newData = role.name.toLowerCase().trim();

    return !roles.some(item => {
      const oldData = item.name.toLowerCase().trim();

      return +item.role_id !== +role.role_id && newData === oldData;
    });
  };

  getPermissionCheckboxes = () => {
    const {
      role: { perm },
      permissions,
      isOwner,
    } = this.props;

    return permissions.map((item, index) => (
      <div className="flex items-center" key={index}>
        <input
          id={`checkbox-${item.name.replace(/[^a-z0-9]/gi, '')}`}
          disabled={isOwner && item.name === 'Admin'}
          data-test={`checkbox-${item.name.replace(/[^a-z0-9]/gi, '')}`}
          type="checkbox"
          name={item.name}
          checked={perm.includes(item.name)}
          className="w-4 h-4 cursor-pointer mr-8"
          onChange={this.onChangePermission}
        />
        <label
          htmlFor={`checkbox-${item.name.replace(/[^a-z0-9]/gi, '')}`}
          className="cursor-pointer poppins-regular"
        >
          {item.name}
        </label>
      </div>
    ));
  };

  getButtons = () => {
    const { isNew, onCancel } = this.props;
    const add = (
      <button
        data-test="button-add"
        className="flex-1 bg-btn-primary-form text-white px-8 py-4 rounded-2xl font-bold uppercase tracking-widest text-xs hover:scale-[1.02] active:scale-[0.98] transition-all shadow-lg shadow-black/20"
        key="1"
        type="submit"
      >
        Add Role
      </button>
    );
    const update = (
      <button
        className="flex-1 bg-btn-primary-form text-white px-8 py-4 rounded-2xl font-bold uppercase tracking-widest text-xs hover:scale-[1.02] active:scale-[0.98] transition-all shadow-lg shadow-black/20"
        key="2"
        data-test="button-update"
        type="submit"
      >
        Update Role
      </button>
    );
    const cancel = (
      <button
        type="button"
        className="px-8 py-4 rounded-2xl font-bold uppercase tracking-widest text-xs text-gray-400 hover:text-black transition-colors border border-transparent hover:border-gray-200"
        key="3"
        data-test="button-cancel"
        onClick={onCancel}
      >
        Cancel
      </button>
    );

    return isNew ? [add, cancel] : [update, cancel];
  };

  render() {
    const {
      auth: {
        user: {
          user: { isSSO },
        },
      },
      role: { name, desc = '' },
    } = this.props;
    const { errors } = this.state;

    return (
      <div className="step-container mt-2 rounded-[2.5rem] border border-gray-200 bg-white p-6 shadow-[0_20px_50px_rgba(0,0,0,0.05)] md:p-8 lg:col-span-8">
        <form onSubmit={this.submit}>
          <fieldset disabled={Boolean(isSSO)}>
            <Grid fluid>
              <Row>
                <Col md={6} className="space-y-6">
                  <div>
                    {this.errorClass(errors.name) && (
                      <span className="text-sunrise font-bold  mt-1 mb-4">{errors.name}</span>
                    )}
                    <div
                      className={classNames(
                        'relative group',
                        this.errorClass(errors.name) ? 'mt-2' : '',
                      )}
                      data-test="roleform-form-group"
                    >
                      <label
                        htmlFor="role-input-name"
                        className="form-label text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 absolute -top-2 left-6 bg-white px-2 transition-all group-focus-within:text-warmth"
                      >
                        Role <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="role-input-name"
                        data-test="input-name"
                        type="text"
                        name="name"
                        value={name}
                        onChange={this.onChange}
                        className="w-full text-xl font-bold px-2 py-3 rounded-2xl border border-gray-200 focus:border-warmth focus:ring-0 transition-all outline-none"
                      />
                    </div>
                  </div>

                  <div>
                    <div className="relative group" data-test="roleform-form-group">
                      <label
                        htmlFor="role-input-desc"
                        className="form-label text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 absolute -top-2 left-6 bg-white px-2 transition-all group-focus-within:text-warmth"
                      >
                        Description
                      </label>
                      <textarea
                        id="role-input-desc"
                        data-test="input-desc"
                        type="text"
                        name="desc"
                        placeholder="Enter description"
                        value={desc}
                        onChange={this.onChange}
                        className="w-full text-sm font-medium px-6 py-5 rounded-2xl border border-gray-200 focus:border-warmth focus:ring-0 transition-all outline-none resize-none"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <FormGroup className="space-y-2">
                    <ControlLabel>Permissions</ControlLabel>
                    {this.getPermissionCheckboxes()}
                  </FormGroup>
                </Col>
              </Row>
            </Grid>
            <div className="pt-6 flex flex-col sm:flex-row gap-4">{this.getButtons()}</div>
          </fieldset>
        </form>
      </div>
    );
  }
}

RoleForm.propTypes = {
  auth: PropTypes.object.isRequired,
  role: PropTypes.object,
  roles: PropTypes.array,
  permissions: PropTypes.array,
  isNew: PropTypes.bool.isRequired,
  isOwner: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
